<template>
  <o-view :has-white-background="true" :no-scroll="true">
    <o-view :bottom-padding="true">
      <o-nav-bar
        title="Q8 Fuel on the Go"
        :has-back-button="true"
        :is-overlay="true"
      />
      <o-message-header
        icon="warning"
        text="Uw profiel is geblokkeerd door Q8"
        :error="true"
      />
      <o-section>
        <p>
          Hier een woordje uitleg. Hier een woordje uitleg. Hier een woordje
          uitleg. Hier een woordje uitleg. Hier een woordje uitleg. Hier een
          woordje uitleg.
        </p>
      </o-section>
    </o-view>
    <o-pay-button label="Sluiten" to="/sales/fuel/" />
  </o-view>
</template>

<script>
import OMessageHeader from '@/components/OMessageHeader.vue'
import OPayButton from '@/components/OPayButton.vue'

export default {
  name: 'CambioOnboardingConfirmation',
  components: {
    OMessageHeader,
    OPayButton
  },
  data() {
    return {}
  }
}
</script>
